module.exports = __webpack_public_path__ + "static/media/05.465248f4.jpg";